/**
 * Khung Đối chiếu nhanh của màn nhập trên máy tính (Doc/11a): mấy con số người nhập cần so với tờ
 * giấy, đổi màu khi vượt ngưỡng. Logic thuần, không DOM.
 *
 * Màu lấy từ chính finding của bộ luật chứ không so ngưỡng lại ở đây: admin sửa hay tắt luật thì khung
 * này đổi theo, không thể báo khác bảng cảnh báo bên dưới nó.
 *
 * Chỉ có ở phiếu `onfarm`: các phiếu khác chưa có chỉ số hay luật nào để đối chiếu.
 */
import { CF_BANDS, extractMetrics, num } from '@farmer/audit-rules';

const toneOf = (findings, code) => {
  if (!code) return null;
  const levels = findings.filter((f) => f.code === code).map((f) => f.level);
  if (levels.includes('error')) return 'bad';
  return levels.includes('warn') ? 'warn' : null;
};

/**
 * @param {object} args
 * @param {string} args.formKey
 * @param {Record<string,string>} args.answers - câu đang hiện, đã trộn lớp master data
 * @param {Array} args.findings - cùng tập với bảng cảnh báo
 * @param {boolean} args.areaPending - diện tích đang theo đề xuất chờ duyệt (Q1)
 * @returns {Array<{key: string, label: string, value: number|null, unit: string, tone: 'bad'|'warn'|null, note?: string}>}
 */
export function quickCheckRows({ formKey, answers, findings, areaPending = false }) {
  if (formKey !== 'onfarm') return [];
  const areaHa = num(answers.coffee_area);
  const metrics = extractMetrics(formKey, answers, areaHa);
  const metric = (key) => metrics.find((m) => m.metricKey === key)?.metricValue ?? null;
  const trees = CF_BANDS.reduce((sum, key) => sum + (num(answers[key]) ?? 0), 0);

  return [
    {
      key: 'area',
      label: 'Diện tích dùng để tính',
      value: areaHa,
      unit: 'ha',
      tone: toneOf(findings, 'A3'),
      ...(areaPending ? { note: 'mới nhất · chờ duyệt' } : {}),
    },
    { key: 'trees', label: 'Tổng số cây cà phê', value: trees || null, unit: 'gốc', tone: null },
    { key: 'density', label: 'Mật độ', value: metric('coffee_density_per_ha'), unit: 'gốc/ha', tone: toneOf(findings, 'A4') },
    { key: 'yield', label: 'Năng suất quả tươi', value: metric('yield_per_ha'), unit: 'kg/ha', tone: toneOf(findings, 'A11') },
    { key: 'inorganic', label: 'Phân vô cơ', value: metric('fert_inorg_per_ha'), unit: 'kg/ha', tone: toneOf(findings, 'A32') },
  ];
}
